module.exports = __webpack_public_path__ + "img/def-scene-2.3131cb5e.jpg";